<!-- фильтр по меткам тикета -->
<template><span style="position: relative">

	<div class="alert alert-info widget-block">
		<div class="widget-filter-ticket-label-wrapper" @click.stop="toggleChoiceBlock">
			<template v-if="curValue === undefined || curValue === null || curValue === '' || curValue === false">{{ 'main/list_all' | ftc }}</template>
			<div v-else class="w5-list-ticket-label"
				:class="'ticket-label-color-' + String(curValue).toLowerCase()"
				:style="'margin-top: 5px; margin-left: 1px; background-color: ' + String(curValue).toLowerCase()"></div>
		</div>
	</div>

	<div v-if="items && typeof items === 'object' && Object.keys(items).length"
		v-show="showChoice === true"
		class="widget-filter-ticket-label-choice"
		style="top: 4px; left: 10px;"
		v-click-outside="hideChoiceBlock">
		<div v-for="(val, idx) in items"
			v-if="String(val) !== ''"
			class="w5-list-ticket-label cursor-pointer"
			:class="'ticket-label-color-' + String(val).toLowerCase()"
			:style="'background-color: ' + String(val).toLowerCase()"
			@click="onClick($event, val)"></div>
		<span v-if="curValue !== undefined && curValue !== null && curValue !== '' && curValue !== false" class="ticket-label-all" @click="clearFilter">{{ 'main/list_all' | ftc }}</span>
	</div>

</span></template>

<script>
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'filterLabel',
	//=========================================================================
	// неизменяемые свойства
	//=========================================================================
	props: ['name', 'value', 'items'],
	//=========================================================================
	// изменяемые свойства
	//=========================================================================
	data() {
		return {
			// выбранное значение фильтра
			curValue: null,
			// показывать выбор метки или нет
			showChoice: false
		}
	},
	//=========================================================================
	// событие: компонент создан
	//=========================================================================
	created() {
		this.curValue = this.value
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// навешиваем обработчик на нажатие клавиш
		document.addEventListener('keydown', this.keyDownHandler)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// убираем обработчики событий
		document.removeEventListener('keydown', this.keyDownHandler)
	},
	//=========================================================================
	// наблюдатели
	//=========================================================================
	watch: {
		'value': function(newValue) {
			this.curValue = newValue
		}
	},
	//=========================================================================
	// функции компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// выбрали значение
		//---------------------------------------------------------------------
		onClick(e, value) {
			// закрываем блок выблра
			this.hideChoiceBlock()
			// запоминаем текущее значение
			this.curValue = value === undefined || value === null || value === '' || value === false ? null : value
			// сообщим родителям что значение поменялось
			this.$emit('input', this.curValue)
		},
		//---------------------------------------------------------------------
		// очистка фильтра
		//---------------------------------------------------------------------
		clearFilter() {
			// закрываем блок выблра
			this.hideChoiceBlock()
			// запоминаем текущее значение
			this.curValue = null
			// сообщим родителям что значение поменялось
			this.$emit('input', this.curValue)
		},
		//---------------------------------------------------------------------
		// обработчик нажатий клавиш
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			// закрытие выбора метки
			if (e.keyCode === 27)
			{
				this.hideChoiceBlock()
			}
		},
		//---------------------------------------------------------------------
		// показ блока выбора
		//---------------------------------------------------------------------
		toggleChoiceBlock() {
			this.showChoice = !this.showChoice
		},
		//---------------------------------------------------------------------
		// звкрытие выбора
		//---------------------------------------------------------------------
		hideChoiceBlock() {
			this.showChoice = false
		}

		//---------------------------------------------------------------------
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
div.widget-block {
	position: relative;
	padding: 9px 10px;
}
</style>

<style>
.widget-filter-ticket-label-wrapper {
	border: 1px solid #ddd;
	background-color: white;
	border-radius: 4px;
	width: 29px;
	height: 29px;
	text-align: center;
	line-height: 29px;
	font-size: 12px;
	cursor: pointer;
	transition: box-shadow .2s;
}

.widget-filter-ticket-label-wrapper:hover {
	border-color: #66afe9;
	box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, .6);
}

.widget-filter-ticket-label-choice {
	position: absolute;
	border: 1px solid #ddd;
	background-color: #eee;
	width: 220px;
	height: 41px;
	border-radius: 4px;
	z-index: 900;
	padding: 6px;

	display: flex;
	display: -webkit-box;
    display: -webkit-flex;

    justify-content: space-between;
	-webkit-justify-content: space-between;

	align-items: center;
	-webkit-align-items: center;
}

.ticket-label-all {
	display: inline-block;
	font-weight: 400;
	color: #666;
	cursor: pointer;
	width: 28px;
}
.ticket-label-all:hover {
	font-weight: 500;
	color: #000;
}
</style>



// WEBPACK FOOTER //
// filterLabel.vue?08804ff7